export var validateSamsungPayPaymentDetailsUpdate = function (samsungPayPaymentDetailsUpdate) {
    if (!samsungPayPaymentDetailsUpdate) {
        return "samsungPayPaymentDetailsUpdate is not defined";
    }
    if (!samsungPayPaymentDetailsUpdate.shippingOptions) {
        return "samsungPayPaymentDetailsUpdate.shippingOptions is not defined";
    }
    if (!Array.isArray(samsungPayPaymentDetailsUpdate.shippingOptions)) {
        return "samsungPayPaymentDetailsUpdate.shippingOptions must be an array";
    }
    if (samsungPayPaymentDetailsUpdate.shippingOptions.length === 0) {
        return "samsungPayPaymentDetailsUpdate.shippingOptions must contain at least one option";
    }
    return null;
};
